import React from 'react';
import styled from 'styled-components';

type DateTimeInputProps = {
  value: string | Date | null;
  onChange: (value: Date | null) => void;
  disabled?: boolean;
  className?: string;
};

export const DateTimeInput: React.FC<DateTimeInputProps> = ({
  value,
  onChange,
  disabled,
  className,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (!raw) {
      onChange(null);
    } else {
      const parsed = new Date(raw);
      if (!isNaN(parsed.getTime())) {
        onChange(parsed);
      }
    }
  };

  const inputValue = React.useMemo(() => {
    if (!value) return '';
    const date = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(date.getTime())) return '';
    // Adjust to local time string for datetime-local input
    const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return offsetDate.toISOString().slice(0, 16); // "yyyy-MM-ddTHH:mm"
  }, [value]);

  return (
    <input
      type="datetime-local"
      value={inputValue}
      onChange={handleChange}
      disabled={disabled}
      className={className}
    />
  );
};

export const StyledDateTimeInput = styled(DateTimeInput)<{ hasValue: boolean }>`
  color: ${({ hasValue }) => (hasValue ? '#222' : '#bbb')};
  padding: 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;
